import React from 'react';
import Button from '../common/Button';

const GymManagement = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <Button 
              onClick={() => window.history.back()}
              variant="outline"
              size="small"
              className="mb-4"
            >
              ← Back to Admin
            </Button>
            <h1 className="text-3xl font-bold text-gray-900">Gym Management</h1>
            <p className="mt-1 text-sm text-gray-600">
              Manage gym settings and configurations
            </p>
          </div>
          
          <div className="bg-white rounded-lg shadow p-6">
            <p className="text-gray-600">Gym management interface coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GymManagement;